'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('antd/lib/icon/style/css');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDIcon = function IDIcon(props) {
    var dataTestID = 'icon';
    var getDataTestId = function getDataTestId() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';
        return props.dataTestID || dataTestID + '-' + prefix;
    };
    var icons = _ConfigGlobal2.default.iconMap;
    // icons = require(`@ant-design/icons`);
    var type = props.type,
        category = props.category;

    if (!type) {
        return "";
    }
    // const arr = type.split("-");
    // let iconType = "";
    // _.each(arr, (string) => {
    //     iconType += string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    // });

    // const IComponent = icons[`${iconType}${category || IDIcon.OUTLINED}`];

    var IComponent = icons[type];
    if (!IComponent) {
        return "";
    }
    return _react2.default.createElement(IComponent, (0, _extends3.default)({}, _lodash2.default.omit(props, 'type'), {
        'data-testid': getDataTestId()
    }));
};

IDIcon.OUTLINED = 'Outlined';
IDIcon.FILLED = 'Filled';
IDIcon.TYPE_INFO = 'TwoTone';

exports.default = IDIcon;